import { el } from 'redom';

import { stringToSVG } from 'utilities';

import hostOfflineIconString from 'assets/images/empty-full-post-view-icon.svg?raw';

const hostOfflineIcon = stringToSVG(hostOfflineIconString);

class HostOfflineView {

  constructor(onMeetingEnded) {

    this.timerReference = null;
    this.remainingSeconds = 120 * 3;
    this.onMeetingEnded = onMeetingEnded;

    this.hostOfflineImage = el('.host-offline-image', hostOfflineIcon.cloneNode(true));

    this.hostOfflineLabel = el('label.host-offline-label', this.getLabelText());

    this.hostOfflineContentContainer = el('.host-offline-content-container', [this.hostOfflineImage, this.hostOfflineLabel]);

    this.el = el('.host-offline-view-main', [this.hostOfflineContentContainer]);

  }

  onmount() {

    this.tryLoopEndMeetingCountdown();

  }

  onunmount() {

    clearTimeout(this.timerReference);

  }

  getLabelText() {

    return `Host is offline. Meeting will automatically end in ${this.remainingSeconds} seconds, if host did not resumed before`;

  }

  updateLabelText() {

    this.hostOfflineLabel.textContent = this.getLabelText();

  }

  tryLoopEndMeetingCountdown() {

    if (this.remainingSeconds === 0) {
      return this.onMeetingEnded();
    }

    this.remainingSeconds--;

    this.timerReference = setTimeout(function oneSecondLater() {
      this.updateLabelText();
      this.tryLoopEndMeetingCountdown();
    }.bind(this), 1000);

  }

}

export default HostOfflineView;